import { addIdsToArray, CustomButton, CustomColumn, CustomTableComponent } from 'src/app/components/table/custom-table/custom-table.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Device                       } from 'src/app/beans/device/device.bean';
import { User                         } from 'src/app/beans/login/user/user.bean';
import { OperatorMin                  } from 'src/app/beans/operator/operator.min';
import { Site                         } from 'src/app/beans/site/site.bean';
import { DeviceSelect                 } from 'src/app/components/select/device/device-select/device.select';
import { OrganizationSelect           } from 'src/app/components/select/organization/organization-select/organization.select';
import { SiteSelect                   } from 'src/app/components/select/site/site-select/site.select';
import { HandlerManager               } from 'src/app/managers/handler/handler.manager';
import { LoadingManager               } from 'src/app/managers/loading/loading.manager';
import { PipeManager                  } from 'src/app/managers/pipe/pipe.manager';
import { SessionManager               } from 'src/app/managers/session/session.manager';
import { Organization } from 'src/app/beans/organization/organization.bean';

@Component
({
  selector: 'assign.operator.page',
  templateUrl: './assign.operator.page.html',
  styleUrls: ['./assign.operator.page.scss']
})
export class AssignOperatorPage implements OnInit
{
  org: Organization
  @ViewChild('orgManager') set _orgSelect(orgSelect: OrganizationSelect){
    if (orgSelect){
      this.setOrg(orgSelect.getSelectedValue())
    }
  }
  site: Site
  @ViewChild('siteManager') set _siteSelect(siteSelect: SiteSelect){
    if (siteSelect){
      this.setSite(siteSelect.getSelectedValue())
    }
  }
  device: Device
  @ViewChild('deviceManager') set _deviceSelect(deviceSelect: DeviceSelect){
    if (deviceSelect){
      this.setDevice(deviceSelect.getSelectedValue())
    }
  }

  @ViewChild('opeAssignTable') opeAssignTable: CustomTableComponent

  assignOperatorColumns: CustomColumn [] = [
    {
      isId   : true,
      label  : "id",
      name   : "id",
      display: ( val : any ) => false ,
    },
    {
      label: "loginName",
      name : "tables.assign_operator.labels.loginName"
    },
    {
      label: "assigned",
      name : "tables.assign_operator.labels.assigned",
      pipe : (assigned: any) => this._pipe.tables().is_assigned(assigned),
    }
  ]

  values: OperatorMin[] = []

  constructor(
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
    private _pipe   : PipeManager
  ) { }

  ngOnInit(): void
  {}

  setOrg(org: Organization)
  {
    this.org = org
    console.log(org);

    this.init()
  }

  setSite( site: Site )
  {
    this.site = site
    this.init()
  }

  setDevice( device: Device )
  {
    this.device = device
    this.init()
  }

   //-----------------------------------------------------------------------------

   async init()
   {
     if(this.org && this.site && this.device)
     {
      let assigned = await this.retriveAssigned(this.device.id);

      //Set operator to assigned
      if(assigned)
      {
        assigned.forEach(element => {
          element.assigned = 1
        });
      }

      let assignable = await this.retriveAssignable( this.device.id );

      if(assignable)
      {
        //Set operator to assignable
        assignable.forEach(element => {
          element.assigned = 0
        });
      }

      this.values = assigned
      this.values = addIdsToArray(this.values.concat(assignable))

      this.values.sort( (a,b) => this._pipe.sorting().sort( a.loginName.toLowerCase(), b.loginName.toLowerCase() ) )
      this.values.sort( (a,b) => this._pipe.sorting().sort( a.loginName.length, b.loginName.length ) )
      this.values.sort( (a,b) => this._pipe.sorting().sort( b.assigned, a.assigned ) )
     }
   }

  //-----------------------------------------------------------------------------

  async retriveAssignable( deviceId: number )
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    //this._loader.start()

    let response = null

    response = await this._handler.operator().assignableList((user as User).token, this.org.id, deviceId)

    this._loader.stop()
    this.opeAssignTable.dataLoaded();

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as OperatorMin[];
  }

  async retriveAssigned( deviceId: number )
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this.opeAssignTable.reloadData()

    this._loader.start()

    let response = null

    response = await this._handler.operator().assignedList((user as User).token, deviceId)

    //this._loader.stop()

    if ( !response      ) return
    if ( !response.list ) return

    return response.list as OperatorMin[];
  }

  //-----------------------------------------------------------------------------

  async changeValue(operator: OperatorMin)
  {
    if     (operator.assigned === 0) await this.assign  (operator.loginId)
    else if(operator.assigned === 1) await this.unassign(operator.loginId)

    this.init()
  }

  async assign(operatorId: number)
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    await this._handler.operator().assign((user as User).token, this.device.id, operatorId)

    this._loader.stop()
  }

  async unassign(operatorId: number)
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    await this._handler.operator().unassign((user as User).token, this.device.id, operatorId)

    this._loader.stop()
  }

  buttons: CustomButton[] = [
    {
      label : "assigned",
      column: "table.operator.assign.action",
      name  : "table.operator.assign.name",
      action: (el: any, pos: number) => {
        this.changeValue(el)
      }
    }
  ]
}
